import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledGameApi = styled(Box)(({ theme }) => ({
    // minHeight: '100vh',
    // height: '100%',
    // position: 'relative',
    // overflow: 'visible',

    [theme.breakpoints.down('md')]: {
        '& .background': {
            '@media (min-width: 320px)': {
                height: '400px !important'
            },
        },
        '& .wave1': {
            '@media (min-width: 320px)': {
                marginTop: '370px !important'
            },
        },
        '& .wave2': {
            '@media (min-width: 320px)': {
                marginTop: '398px !important'
            },
        }
    },
}));

export default StyledGameApi;
